import { uic, uiconfig } from '../utils'

export const inputConfig = uiconfig({
	baseClass: [
		'flex w-full bg-card text-foreground',
		'transition-[box-shadow,border-color] duration-150',
		'file:border-0 file:bg-transparent file:text-sm file:font-medium',
		'placeholder:text-muted-foreground/70',
		'focus-visible:outline-none',
		'disabled:cursor-not-allowed disabled:opacity-50',
		'read-only:bg-secondary/60 read-only:text-muted-foreground',
		'data-[invalid]:border-destructive data-[invalid]:ring-destructive',
	],
	variants: {
		inputSize: {
			default: 'h-9 rounded-md px-2.5 py-1.5 text-sm',
			sm: 'h-7 rounded-sm px-2 py-1 text-sm',
			lg: 'h-11 rounded-md px-3 py-2 text-base',
		},
		variant: {
			default: [
				'border border-input',
				'shadow-[inset_0_1px_0_0_rgba(20,20,15,0.03),0_1px_0_0_rgba(20,20,15,0.02)]',
				'hover:border-foreground/30',
				'focus-visible:border-foreground',
				'focus-visible:shadow-[inset_0_1px_0_0_rgba(20,20,15,0.03),0_0_0_3px_rgba(20,20,15,0.08)]',
			].join(' '),
			ghost: 'border-transparent border-b border-border focus-visible:border-foreground/60 rounded-none bg-transparent',
		},
	},
	defaultVariants: {
		variant: 'default',
		inputSize: 'default',
	},
})

export const Input = uic('input', {
	...inputConfig,
	displayName: 'Input',
})

export const InputLike = uic('div', {
	baseClass: [
		'flex items-center min-h-9 w-full rounded-md border border-input bg-card px-2.5 py-1.5 text-sm',
		'transition-[box-shadow,border-color] duration-150',
		'shadow-[inset_0_1px_0_0_rgba(20,20,15,0.03),0_1px_0_0_rgba(20,20,15,0.02)]',
		'file:border-0 file:bg-transparent file:text-sm file:font-medium',
		'placeholder:text-muted-foreground/70',
		'focus-within:outline-none focus-within:border-foreground',
		'focus-within:shadow-[inset_0_1px_0_0_rgba(20,20,15,0.03),0_0_0_3px_rgba(20,20,15,0.08)]',
		'disabled:cursor-not-allowed disabled:opacity-50',
	],
	displayName: 'InputLike',
})

/**
 * without any styling, without ring, border etc; so it must be resetted
 */
export const InputBare = uic('input', {
	baseClass: 'w-full h-full focus-visible:outline-hidden',
	displayName: 'InputBare',
})

export const CheckboxInput = uic('input', {
	baseClass: 'w-4 h-4',
	defaultProps: {
		type: 'checkbox',
	},
})

export const RadioInput = uic('input', {
	baseClass: `
		appearance-none bg-background rounded-full w-4 h-4 ring-1 ring-gray-400 hover:ring-gray-600 grid place-items-center
		before:rounded-full before:bg-gray-600 before:w-2 before:h-2 before:ring-2 before:ring-white before:content-[''] before:transform  before:transition-all before:scale-0 checked:before:scale-100
	`,
})
